/* eslint-disable new-cap */
import moment from 'moment';

export const timePeriod = {
  thisWeek: 'this_week',
  previousWeek: 'previous_week',
  thisMonth: 'this_month',
  previousMonth: 'previous_month',
  custom: 'custom',
};

export const thisWeek = () => {
  const from = new moment().day(1).toDate();
  const to = new moment().day(7).toDate();
  return [from, to];
};

export const previousWeek = () => {
  const from = new moment().subtract(1, 'week').day(1).toDate();
  const to = new moment().subtract(1, 'week').day(7).toDate();
  return [from, to];
};

export const thisMonth = () => {
  const from = new moment().startOf('month').toDate();
  const to = new moment().endOf('month').toDate();
  return [from, to];
};

export const previousMonth = () => {
  const from = new moment().subtract(1, 'month').startOf('month').toDate();
  const to = new moment().subtract(1, 'month').endOf('month').toDate();
  return [from, to];
};

export const custom = (dateFrom, dateTo) => {
  const from = new moment(dateFrom).toDate();
  const to = new moment(dateTo).toDate();
  return [from, to];
};

export const getPeriod = (period, dateFrom, dateTo) => {
  switch (period) {
    case timePeriod.thisWeek:
      return thisWeek();
    case timePeriod.previousWeek:
      return previousWeek();
    case timePeriod.thisMonth:
      return thisMonth();
    case timePeriod.previousMonth:
      return previousMonth();
    case timePeriod.custom:
      return custom(dateFrom, dateTo);
    default:
      return thisWeek();
  }
};

export const getPeriodFromOptions = (options) => {
  const period = options.period;
  const dateFrom = options.dateFrom;
  const dateTo = options.dateTo;
  return getPeriod(period, dateFrom, dateTo);
};



// WEBPACK FOOTER //
// ./src/utils/calendar.js